import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './jet/Header';
import Footer from './jet/Footer';
import Home from './jet/Home';
import Fleet from './jet/Fleet';
import Safety from './jet/Safety';
import Quote from './jet/Quote';

// Stratos — multi-page Signature template. Data-cockpit dashboard rhythm,
// onyx + ice + signal-red palette. Distinct skeleton from Watch & Yacht.
export default function JetTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#0F0F11]" data-testid="jet-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} data-testid={`jet-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'fleet' && <Fleet setPage={setPage} />}
          {page === 'safety' && <Safety setPage={setPage} />}
          {page === 'quote' && <Quote setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
